import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import Tips from '@/pages/components/tips/index';
import alert from '@/pages/components/common/alert';
import './scss/form.scss'

interface initProps {
	history: any,
}

class SetPassword extends React.Component <initProps , any> {
	constructor(props: any) {
		super(props);
		this.state = {
			visiblity: this.props.history.location.search ? ( this.GetQueryString('from') === 'register' ? true : false ) : false,
			from: this.props.history.location.search ? ( this.GetQueryString('from') === 'register' ? 'register' : '' ) : '', // 入口页
			form: {
				password: '',
				password2: '',
				email: '',
				trader: '',
			}
		};
	}

	componentDidMount() { 
		if ((window as any)._hmt) {
			(window as any)._hmt.push(['_trackPageview', '/mobile/uc/build/set_password']);
		}
	}

	render() {
		return (
			<div className="gray-bg">
				<Tips 
					visiblity = {this.state.visiblity} 
					titleText={this.state.from === 'register' ? '注册成功' : '' }
					promptText="欢迎来到买化塑！为了您的账号安全请及时设置密码并完善邮箱地址。"  
					confirmFn={() => this.setState({visiblity: false}) } />
				<div className="default-form2">
					<div className="form-input-warrper">
						<label className="label"><span>*</span>新密码</label>
						<input type="password" placeholder="请输入6-16位登录密码" className="text-right" value={this.state.form.password} onChange={ (e:any) => this.setForm('password', e.target.value) } />
					</div>
					<div className="form-input-warrper">
						<label className="label"><span>*</span>确认密码</label>
						<input type="password" placeholder="请再次输入新密码" className="text-right" value={this.state.form.password2} onChange={ (e:any) => this.setForm('password2', e.target.value) } />
					</div>
					<div className="form-input-warrper">
						<label className="label"><span>*</span>电子邮箱</label>
						<input type="text" placeholder="请输入邮箱" className="text-right"  value={this.state.form.email} onChange={ (e:any) => this.setForm('email', e.target.value) } />
					</div>
					<div className="form-input-warrper">
						<label className="label">我的业务员</label>
						<input type="text" placeholder="请输入业务员" className="text-right" value={this.state.form.trader} onChange={ (e:any) => this.setForm('trader', e.target.value) }/>
					</div>

				</div>
				<div className="form-btn-warrrper">
					<button className="form-btn" onClick={() => this.submitForm() }>提交</button>	
					<span className="form-btn-cancel" onClick={() => this.cancelSetting()}>暂不设置</span>	
				</div>
			</div>
		)
	}

	private getOuthBackUrl() {
		const returnUrl = GetQueryString('returnUrl');
		function GetQueryString(name: any)
		{
		     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		     var r = window.location.search.substr(1).match(reg);
		     if(r!=null)return  r[2]; return null;
		}

		if(returnUrl) {
			return returnUrl
		}else {
			return encodeURIComponent(encodeURIComponent(window.location.origin + '/mobile/uc/build'))
		}
	}

	private GetQueryString(name: any) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		var r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return null;
	}

	private setForm(name?: string, val?: any) {
		if(!name) {
			return ;
		}
		this.state.form[name] = val.replace(/\s*/gi, '');
		this.setState({
			form: { 
				...this.state.form,
			} 
		})
	}

	private checkForm() {
		if(this.state.form.password.replace(/\s/gi, '') === '') {
			alert.open({
				promptText: '请输入密码',
			})

			return ;
		}
		if(!/^(?=.*\d)(?=.*[a-zA-Z])[a-zA_Z0-9]{6,16}$/gi.test(this.state.form.password)) {
			alert.open({
				promptText: '密码格式有误！请输入6-16字母与数字组合',
			})

			return ;
		}
		if(this.state.form.password2.replace(/\s/gi, '') === '') {
			alert.open({
				promptText: '请确认密码',
			})

			return ;
		}

		if(this.state.form.password2.replace(/\s/gi, '') !== this.state.form.password.replace(/\s/gi, '') ) {
			alert.open({
				promptText: '两次密码不一致！',
			})

			return ;
		}
		if(this.state.form.email.replace(/\s/gi, '') === '') {
			alert.open({
				promptText: '请输入邮箱',
			})
			return ;
		}
		if(!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/gi.test(this.state.form.email)) {
			alert.open({
				promptText: '邮箱格式有误！',
			})

			return ;
		}
		return true;
	}

	private async submitForm() {
		// const that = this;
		if(!this.checkForm()) {
			return ;
		}

		const r = await request({
			method: "post",
			url: `${config.WAPAPI}security/setPwd`,
			data: {
				...this.state.form,
			}
		})

		if(r.code === 1) {
			alert.open({
				promptText: '设置密码成功',
				callback: () => {
					window.location.href = decodeURIComponent(decodeURIComponent(this.getOuthBackUrl()));
				}
			})
		}else {
			alert.open({
				promptText: r.msg,
			})
		}
		
	}

	// 暂不设置
	private cancelSetting() {
		window.location.href = decodeURIComponent(decodeURIComponent(this.getOuthBackUrl()));
	}
}

export default SetPassword;